import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const XIcon: React.FC<IconProps> = ({ size, style, color, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg style={style} xmlns="http://www.w3.org/2000/svg" width={size ?? '20'} height={size ?? '21'} fill="none" viewBox="0 0 31 31" data-testid="twitter-icon">
      <path fill={`${color ? secondaryColor || theme.palette.primary.main : '#000'}`} d="M0 0h32v32H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M12.002 6.125H5.187l8.08 10.672-7.563 8.953H9.2l5.72-6.771 5.079 6.709h6.814l-8.314-10.983.015.02 7.159-8.475h-3.495l-5.316 6.293-4.859-6.418ZM8.95 7.995h2.122l11.98 15.824h-2.122L8.95 7.994Z"
        clipRule="evenodd"
      />
    </svg>
  );
};

export default XIcon;
